import ChatBot from "./ChatBot";
export default function HomePage() {  
  return (
    <div className="home">
      <ChatBot />
    </div>
  );
}